import { Loft } from '../classes/Golfer';

export class GappingSequence {
  pwLoft: Loft;
  highestLoft: Loft;
  gapping: string;
}

export class GappingSequences {
  data: GappingSequence[];

  constructor() {
    this.data =
      [
        {
          "pwLoft": '43',
          "highestLoft": '56',
          "gapping": "48 52 56"
        },
        {
          "pwLoft": '43',
          "highestLoft": '58',
          "gapping": "48 54 58"
        },
        {
          "pwLoft": '43',
          "highestLoft": '60',
          "gapping": "48 54 60"
        },
        {
          "pwLoft": '44',
          "highestLoft": '56',
          "gapping": "44 48 52 56"
        },
        {
          "pwLoft": '44',
          "highestLoft": '58',
          "gapping": "44 50 54 58"
        },
        {
          "pwLoft": '44',
          "highestLoft": '60',
          "gapping": "44 50 54 60"
        },
        {
          "pwLoft": '45',
          "highestLoft": '56',
          "gapping": "50 56"
        },
        {
          "pwLoft": '45',
          "highestLoft": '58',
          "gapping": "50 54 58"
        },
        {
          "pwLoft": '45',
          "highestLoft": '60',
          "gapping": "50 54 60"
        },
        {
          "pwLoft": '46',
          "highestLoft": '56',
          "gapping": "46 50 56"
        },
        {
          "pwLoft": '46',
          "highestLoft": '58',
          "gapping": "46 50 54 58"
        },
        {
          "pwLoft": '46',
          "highestLoft": '60',
          "gapping": "46 50 54 60"
        },
        {
          "pwLoft": '47',
          "highestLoft": '56',
          "gapping": "52 56"
        },
        {
          "pwLoft": '47',
          "highestLoft": '58',
          "gapping": "52 58"
        },
        {
          "pwLoft": '47',
          "highestLoft": '60',
          "gapping": "52 56 60"
        },
        {
          "pwLoft": '48',
          "highestLoft": '56',
          "gapping": "48 52 56"
        },
        {
          "pwLoft": '48',
          "highestLoft": '58',
          "gapping": "48 54 58"
        },
        {
          "pwLoft": '48',
          "highestLoft": '60',
          "gapping": "48 52 56 60"
        },
      ]
  }
}
